import { graphql } from 'src/graphql';

export const AddAcquisitionSource = graphql(`
  mutation addAcquisitionSource($user: UserInput!) {
    updateMe(user: $user) {
      _id
    }
  }
`);
